<script setup>
import { ref, onMounted } from "vue";
import V4CompletedContentModal from "@/components/home/my-progress/V4CompletedContentModal.vue";
import { useCompletedContentStore } from "@/stores/home/useCompletedContent.store";
import { storeToRefs } from "pinia";
import V4StatCard from "./partials/V4StatCard.vue";

const completedContentStore = useCompletedContentStore();

const showCompletedContentModal = ref(false);
const { loadingContentCard, totalCount } = storeToRefs(completedContentStore);

const handleClickCard = () => {
  showCompletedContentModal.value = true;
};

onMounted(() => {
  completedContentStore.handleFetchTotalCount();
});
</script>

<template>
  <template v-if="loadingContentCard">
    <div
      v-for="n in 1"
      :key="n"
      class="flex-1 min-w-[140px] rounded-md border border-untitled-gray-200 bg-white p-4"
    >
      <div class="h-8 w-16 rounded bg-untitled-gray-200 animate-pulse" />
      <div class="h-4 w-24 rounded bg-untitled-gray-200 animate-pulse mt-2" />
    </div>
  </template>
  <V4StatCard
    v-else
    :stat="{
      title: 'Completed Contents',
      value: totalCount,
      key: 'completed_contents',
    }"
    @on-click-card="handleClickCard"
  />
  <V4CompletedContentModal
    v-if="showCompletedContentModal"
    v-model="showCompletedContentModal"
  />
</template>

<style scoped lang="scss"></style>
